module.exports = __webpack_public_path__ + "img/ENlogo@2x.d993414f.png";